import React from 'react';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import { connect } from 'react-redux';
import './Inheritage.css';
import { sourceTypes } from '../../../../../constants/cms/sourceType';
import PolicyIcon from '@material-ui/icons/Policy';
import CloseIcon from '@material-ui/icons/Close';
import { Row, Col } from 'reactstrap';
import Avatar from '@material-ui/core/Avatar';
import { IconButton } from '@material-ui/core';

const InheritageButtonGroup = (props) => {
    const { cms, status, onClick, form } = props;
    let disabled = cms.enviroment == sourceTypes.FORM && form.inherit !== null && form.inheritParentId !== null? true : false;
    return (
        <div style={{ padding: '20px 0px' }}>
            <Row>
                <Col className="col-2 ">
                    <IconButton disabled={disabled} onClick={() => onClick(null)} className={`inherit-toggle-icon${status === null ? '-active' : ''}`}>
                        <Avatar><CloseIcon /></Avatar>
                    </IconButton>
                </Col>
                <Col className="col-10 inherit-info-text-col">
                    <p>
                        Har ej någon koppling till ett annat formulär i din organisation
            </p>
                </Col>
            </Row>
            <Row>
                <Col className="col-2 ">
                    <IconButton disabled={disabled} onClick={() => onClick(false)} className={`inherit-toggle-icon${status === false ? '-active' : ''}`}>
                        <Avatar><PolicyIcon /></Avatar>
                    </IconButton>
                </Col>
                <Col className="col-10 inherit-info-text-col">
                    <p>
                        Andra formulär i som ärver av detta formulär har endast läsrättigheter men kan ej editera formuläret
                    </p>
                </Col>
            </Row>
            <Row>
                <Col className="col-2 ">
                    <IconButton disabled={disabled} onClick={() => onClick(true)} className={`inherit-toggle-icon${status === true ? '-active' : ''}`}>
                        <Avatar><AccountTreeIcon /></Avatar>
                    </IconButton>
                </Col>
                <Col className="col-10 inherit-info-text-col">
                    <p>
                        Andra formulär som ärver detta formulär har läsrättigheter och kan editera formuläret men då kommer en ny kopia skapas.
                </p>
                </Col>
            </Row>
        </div>
    )

}
function mapStateToProps(state) {

    return {
        cms: state.cms,
        form: state.form
    };
}

export default connect(mapStateToProps)(InheritageButtonGroup);
